let TCIntl;

let missingOptionalPeerDep = false;

// Check if these modules are installed since they
// are optional peer dependencies
const optionalPeerDeps = [
	'@google-cloud/translate',
	'@techchange/pm-specs',
	'@techchange/request',
	'cld',
	'deepl-node',
	'prosemirror-model',
];

for (const optionalPeerDep of optionalPeerDeps) {

	try {

		// eslint-disable-next-line global-require
		require(optionalPeerDep);

	} catch (error) {

		// eslint-disable-next-line max-len
		console.warn(`Missing optional peer dependency ${optionalPeerDep}. Install this package in order to use the TCIntl class`);

		missingOptionalPeerDep = true;

	}

}

if (missingOptionalPeerDep) {
	TCIntl = null;
} else {
	// eslint-disable-next-line global-require
	TCIntl = require('./TCIntl');
}

module.exports = TCIntl;
